import { render, staticRenderFns } from "./PromotionCodesPage.vue?vue&type=template&id=297d6452&"
import script from "./PromotionCodesPage.vue?vue&type=script&lang=js&"
export * from "./PromotionCodesPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCodesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports